document.addEventListener('DOMContentLoaded', function () {

  // ─── DATA ────────────────────────────────────────────────────────────────
  const models = {
    kayro:   ['Urban Ash', 'Army Green', 'Rose Gold', 'Ocean Edge'],
    valor:   ['Onyx Black', 'Silver Crest', 'Saga Mint', 'Blush Gold'],
    ranger:  ['Shadow Black', 'Saga Green', 'Desert Tan', 'Steel Gray'],
    marshal: ['Jet Black', 'Imperial Bronze', 'Royal Sage', 'Emerald Green']
  };

  const colorMap = {
    'Urban Ash':       '#5D564D', 'Army Green':      '#435039', 'Rose Gold':       '#9A7064',
    'Ocean Edge':      '#00C4CD', 'Onyx Black':      '#18181A', 'Silver Crest':    '#D2D1D4',
    'Saga Mint':       '#C4DCCB', 'Blush Gold':      '#967E66', 'Shadow Black':    '#1F1F1F',
    'Saga Green':      '#91AE9B', 'Desert Tan':      '#A5958A', 'Steel Gray':      '#AAABAF',
    'Jet Black':       '#212325', 'Imperial Bronze': '#9B6F53', 'Royal Sage':      '#577A73',
    'Emerald Green':   '#3E6767'
  };

  // ─── DOM REFERENCES ────────────────────────────────────────────────────
  const modelInputs       = document.querySelectorAll('input[name="bag-model"]');
  const sizeInputs        = document.querySelectorAll('input[name="bag-size"]');
  const interiorInputs    = document.querySelectorAll('input[name="bag-interior"]');
  const addonsCheckboxes  = document.querySelectorAll('.addon-card input[type="checkbox"]');
  const colorInput        = document.getElementById('bag-color');
  const colorContainer    = document.getElementById('color-options');

  const previewModel          = document.getElementById('preview-model');
  const previewModelMobile    = document.getElementById('preview-model-mobile');
  const previewInterior       = document.getElementById('preview-interior');
  const previewInteriorMobile  = document.getElementById('preview-interior-mobile');
  const previewAddonsContainer = document.getElementById('preview-addons');
  const previewAddonsMobileContainer = document.getElementById('preview-addons-mobile');
  const placeholderText        = document.getElementById('placeholder-text');

  const finalPriceEl    = document.getElementById('final-price');
  const finalSubtotalEl = document.getElementById('final-subtotal');
  const qtyInput        = document.getElementById('bag-quantity');
  const btnMinus        = document.querySelector('.qty-minus');
  const btnPlus         = document.querySelector('.qty-plus');
  
  const tabBtns         = document.querySelectorAll('.tab-btn');
  const tabPanes        = document.querySelectorAll('.tab-pane');
  
  const addToCartBtn    = document.getElementById('add-to-cart-btn');
  const buyNowBtn       = document.getElementById('buy-now-btn');
  const stickyAtcBtn    = document.getElementById('sticky-atc-btn');
  const stickyPriceEl   = document.getElementById('sticky-price');
  
  const successMsg      = document.getElementById('cart-success');
  const errorMsg        = document.getElementById('cart-error');

  // ─── HELPERS ──────────────────────────────────────────────────────────
  function getModel() {
    const checked = document.querySelector('input[name="bag-model"]:checked');
    return checked ? checked.value : 'kayro';
  }
  function getSizeInput() { return document.querySelector('input[name="bag-size"]:checked'); }
  function getInterior() { return document.querySelector('input[name="bag-interior"]:checked')?.value || 'dshape'; }
  function getAssetUrl(filename) { return (window.faujiAssetUrl || '') + filename; }

  // Resolve image URL: try custom uploaded image first, then fallback to asset
  function resolveImageUrl(key, fallbackFilename) {
    if (window.faujiUploads && window.faujiUploads[key]) {
      return window.faujiUploads[key];
    }
    return getAssetUrl(fallbackFilename);
  }

  // ─── PRELOADING ──────────────────────────────────────────────────────
  function preloadImages() {
    console.log('Builder: Preloading assets...');
    const list = [];
    Object.keys(models).forEach(m => {
      list.push(getAssetUrl(m + '.png'));
      models[m].forEach(c => list.push(getAssetUrl(m + '-' + c.toLowerCase().replace(/\s+/g, '-') + '.png')));
    });
    interiorInputs.forEach(i => list.push(getAssetUrl('interior-' + i.value + '.png')));
    addonsCheckboxes.forEach(a => list.push(getAssetUrl('addon-' + a.value + '.png')));
    list.forEach(url => { const img = new Image(); img.src = url; });
  }

  // ─── COLOR SWATCHES (ROUND STYLE) ─────────────────────────────────────
  function updateColorOptions(model, skipUpdate = false) {
    if (!colorContainer) return;
    colorContainer.innerHTML = '';
    const colors = models[model] || [];

    colors.forEach((color, index) => {
      const colorSlug = color.toLowerCase().replace(/\s+/g, '-');
      const hex = colorMap[color] || '#ccc';

      const wrap = document.createElement('div');
      wrap.className = 'swatch-wrap';

      const swatch = document.createElement('div');
      swatch.className = 'swatch' + (index === 0 ? ' active' : '');
      swatch.dataset.value = colorSlug;
      swatch.dataset.name = color;
      // Inline styles ensure circle renders even if CSS loads late
      swatch.style.cssText = [
        'display:block',
        'width:40px',
        'height:40px',
        'border-radius:50%',
        'background-color:' + hex,
        'border:3px solid #fff',
        'box-shadow:0 0 0 1.5px #ccc',
        'transition:transform 0.2s,box-shadow 0.2s',
        'cursor:pointer',
        'flex-shrink:0'
      ].join(';');

      const label = document.createElement('span');
      label.className = 'swatch-label';
      label.textContent = color;

      wrap.appendChild(swatch);
      wrap.appendChild(label);

      wrap.addEventListener('click', () => {
        // Reset all swatches
        colorContainer.querySelectorAll('.swatch').forEach(s => {
          s.classList.remove('active');
          s.style.boxShadow = '0 0 0 1.5px #ccc';
          s.style.transform = 'scale(1)';
        });
        // Activate clicked
        swatch.classList.add('active');
        swatch.style.boxShadow = '0 0 0 2.5px #1a1a1a';
        swatch.style.transform = 'scale(1.12)';
        colorInput.value = colorSlug;
        colorInput.dataset.name = color;
        updateImages();
      });
      colorContainer.appendChild(wrap);

      if (index === 0) {
        colorInput.value = colorSlug;
        colorInput.dataset.name = color;
      }
    });
    if (!skipUpdate) updateImages();
  }

  // ─── PRICE & SUBTOTAL ─────────────────────────────────────────────────
  function calculatePrice() {
    const sizeEl = getSizeInput();
    if (!sizeEl) return;
    const sizePrice = parseInt(sizeEl.dataset.price, 10) || 0;
    
    // Add-ons Price
    let addonsPrice = 0;
    addonsCheckboxes.forEach(cb => { if (cb.checked) addonsPrice += parseInt(cb.dataset.price, 10) || 0; });

    // Interior Price
    const interiorEl = document.querySelector('input[name="bag-interior"]:checked');
    const interiorPrice = interiorEl ? (parseInt(interiorEl.dataset.price, 10) || 0) : 0;

    const baseUnitTotal = sizePrice + addonsPrice + interiorPrice;
    const qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
    const subtotal = baseUnitTotal * qty;

    if (finalPriceEl) finalPriceEl.textContent = '₹' + baseUnitTotal.toLocaleString('en-IN');
    if (finalSubtotalEl) finalSubtotalEl.textContent = '₹' + subtotal.toLocaleString('en-IN');
    if (stickyPriceEl) stickyPriceEl.textContent = '₹' + subtotal.toLocaleString('en-IN');
    
    updateDynamicTitle();
    updateSizeVisuals();
  }

  // ─── SIZE SCALING ───────────────────────────────────────────────────
  function updateSizeVisuals() {
    const sizeInput = getSizeInput();
    if (!sizeInput) return;
    
    const size = sizeInput.value;
    const builderContainer = document.querySelector('.fauji-bag-builder');
    if (!builderContainer) return;

    let scale = 1.0;
    let blur = '35px';

    if (size === '55') { // Small
      scale = 0.9;
      blur = '25px';
    } else if (size === '65') { // Medium
      scale = 1.0;
      blur = '35px';
    } else if (size === '75') { // Large
      scale = 1.08;
      blur = '45px';
    }

    builderContainer.setAttribute('data-size', size === '55' ? 'small' : (size === '65' ? 'medium' : 'large'));

    builderContainer.style.setProperty('--size-scale', scale);
    builderContainer.style.setProperty('--size-shadow-blur', blur);
  }

  // ─── DYNAMIC TITLE ───────────────────────────────────────────────────
  function updateDynamicTitle() {
    const titleEl = document.getElementById('dynamic-build-title');
    if (!titleEl) return;
    
    const parts = [];
    
    // Model
    const modelRaw = getModel() || '';
    if (modelRaw) parts.push(modelRaw.charAt(0).toUpperCase() + modelRaw.slice(1));
    
    // Color
    const colorStr = colorInput.dataset.name || '';
    if (colorStr) parts.push(colorStr);
    
    // Interior
    const interiorInput = document.querySelector('input[name="bag-interior"]:checked');
    const interiorStr = interiorInput ? (interiorInput.closest('.option-card').querySelector('.addon-name')?.textContent?.trim() || '') : '';
    if (interiorStr) parts.push(interiorStr);
    
    // Addons
    const addonsList = Array.from(addonsCheckboxes).filter(cb => cb.checked).map(cb => cb.dataset.name);
    let addonsStr = '';
    if (addonsList.length > 0) {
      if (addonsList.length > 2) {
        addonsStr = ' + ' + addonsList.slice(0, 2).join(' + ') + ` + ${addonsList.length - 2} more`;
      } else {
        addonsStr = ' + ' + addonsList.join(' + ');
      }
    }
    
    titleEl.textContent = parts.join(' • ') + addonsStr;
  }

  // ─── IMAGE PREVIEW ───────────────────────────────────────────────────
  function updateImages() {
    if (!previewModel) return;
    const model = getModel();
    const color = colorInput?.value || '';
    const interior = getInterior();

    // Exterior Bag (Desktop & Mobile)
    const colorSlug = colorInput?.value.replace(/[^a-z0-9]+/g, '-') || '';
    const baseKey = model + (colorSlug ? '-' + colorSlug : '');
    const fallbackFilename = colorSlug ? model + '-' + colorSlug + '.png' : model + '.png';
    const targetSrc = resolveImageUrl(baseKey, fallbackFilename);

    if (previewModel.getAttribute('src') !== targetSrc) {
      previewModel.src = targetSrc;
    }
    if (previewModelMobile && previewModelMobile.getAttribute('src') !== targetSrc) {
      previewModelMobile.src = targetSrc;
    }

    // Interior View (Desktop & Mobile)
    if (previewInterior) {
      if (interior) {
        const intKey = 'interior-' + interior;
        const fallbackIntFilename = intKey + '.png';
        const intSrc = resolveImageUrl(intKey, fallbackIntFilename);
        
        // Anti-flicker: Only update src if it does not already have the exact image loaded
        if (previewInterior.getAttribute('src') !== intSrc) {
          previewInterior.src = intSrc;
        }
        if (previewInteriorMobile && previewInteriorMobile.getAttribute('src') !== intSrc) {
          previewInteriorMobile.src = intSrc;
        }
        
        previewInterior.style.display = 'block';
        if (previewInteriorMobile) previewInteriorMobile.style.display = 'block';
        if (placeholderText) placeholderText.style.display = 'none';
      } else {
        previewInterior.style.display = 'none';
        if (previewInteriorMobile) previewInteriorMobile.style.display = 'none';
        if (placeholderText) placeholderText.style.display = 'block';
      }
    }
  }

  // Formatter specifically for Add-on names -> filename matching
  function formatAddonName(val) {
    if (!val) return '';
    return val.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function updateAddonImages() {
    const containers = [previewAddonsContainer, previewAddonsMobileContainer].filter(Boolean);
    if (containers.length === 0) return;
    
    // Clear all containers to rebuild the multi-layered stack from scratch
    containers.forEach(container => container.innerHTML = '');
    
    // Loop through ALL checkboxes to support multi-addon stacking
    addonsCheckboxes.forEach(cb => {
      if (!cb.checked) return;

      const formattedVal = formatAddonName(cb.value);
      const addonKey = 'addon-' + formattedVal;
      const fallbackFilename = addonKey + '.png';
      const imgSrc = resolveImageUrl(addonKey, fallbackFilename);

      containers.forEach(container => {
        const img = document.createElement('img');
        img.className = 'addon-overlay'; // Matches the absolute position CSS
        img.src = imgSrc;
        img.alt = '';
        img.onerror = function() { this.style.display = 'none'; };
        container.appendChild(img);
      });
    });
  }

  // ─── ADDON EXCLUSIVITY (Combo Logic) ──────────────────────────────────
  function syncAddonExclusivity(clickedCb) {
    const comboValue = 'ultimate-combo';
    const isCombo = clickedCb.value === comboValue;
    
    if (isCombo && clickedCb.checked) {
      // Select Travel Combo -> Uncheck and disable all other individual addons
      addonsCheckboxes.forEach(cb => {
        if (cb.value !== comboValue) {
          cb.checked = false;
          cb.disabled = true;
          cb.closest('.option-card').classList.add('disabled-addon');
        }
      });
    } else if (isCombo && !clickedCb.checked) {
      // Deselect Travel Combo -> Re-enable all individuals
      addonsCheckboxes.forEach(cb => {
        cb.disabled = false;
        cb.closest('.option-card').classList.remove('disabled-addon');
      });
    } else if (!isCombo) {
      // Check if any individual addon is selected
      const anyIndividualChecked = Array.from(addonsCheckboxes).some(cb => cb.value !== comboValue && cb.checked);
      const comboCb = Array.from(addonsCheckboxes).find(cb => cb.value === comboValue);
      
      if (anyIndividualChecked) {
        // If any individual selected -> Disable the Travel Combo
        if (comboCb) {
          comboCb.checked = false;
          comboCb.disabled = true;
          comboCb.closest('.option-card').classList.add('disabled-addon');
        }
      } else {
        // If no individuals selected -> Enable the Travel Combo
        if (comboCb) {
          comboCb.disabled = false;
          comboCb.closest('.option-card').classList.remove('disabled-addon');
        }
      }
    }
  }

  // ─── ADD TO CART (Logic Fix) ──────────────────────────────────────────
  function handleCheckout(redirect = false) {
    if (!addToCartBtn) return;
    
    // Clear previous messages
    if (successMsg) successMsg.style.display = 'none';
    if (errorMsg) errorMsg.style.display = 'none';
    
    addToCartBtn.classList.add('loading');
    addToCartBtn.disabled = true;

    const variantId = window.faujiVariantId;
    if (!variantId) {
      console.error('Fauji Builder: Variant ID missing.');
      addToCartBtn.classList.remove('loading');
      addToCartBtn.disabled = false;
      return;
    }

    const modelVal    = getModel();
    const sizeVal     = getSizeInput()?.value || '';
    const colorVal    = colorInput.dataset.name || '';
    const interiorElChecked = document.querySelector('input[name="bag-interior"]:checked');
    const interiorVal = interiorElChecked ? (interiorElChecked.closest('.option-card').querySelector('.addon-name')?.textContent?.trim() || 'Default') : 'Default';

    // Build Native Cart Split Array (Option 3)
    const items = [];
    const mainQty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
    
    // 1. Base Bag
    items.push({
      id: variantId,
      quantity: mainQty,
      properties: {
        'Model':    modelVal.toUpperCase(),
        'Size':     sizeVal + ' cm',
        'Color':    colorVal,
        'Interior': interiorVal
      }
    });

    // 2. Extracted Add-ons as unique Line Items
    Array.from(addonsCheckboxes).filter(cb => cb.checked).forEach(cb => {
      const formattedVal = formatAddonName(cb.value);
      const addonVid = window.faujiAddonProducts && window.faujiAddonProducts[formattedVal];
      
      if (addonVid && addonVid !== 'null' && addonVid !== null) {
        items.push({
          id: parseInt(addonVid, 10),
          quantity: mainQty
        });
      }
    });

    // 3. Interior Upgrade (Secret line item if price > 0)
    const interiorEl = document.querySelector('input[name="bag-interior"]:checked');
    if (interiorEl && interiorEl.value !== 'dshape') {
      const intKey = interiorEl.value === 'dshape-mesh' ? 'interior-mesh' : 'interior-mesh-wet';
      const intVid = window.faujiAddonProducts && window.faujiAddonProducts[intKey];
      if (intVid && intVid !== 'null' && intVid !== null) {
        items.push({
          id: parseInt(intVid, 10),
          quantity: mainQty
        });
      }
    }

    const cartData = { items: items };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartData)
    })
    .then(response => {
      if (!response.ok) return response.json().then(d => { throw d; });
      return response.json();
    })
    .then(() => {
      if (redirect) {
        window.location.href = '/checkout';
        return;
      }
      addToCartBtn.classList.remove('loading');
      addToCartBtn.disabled = false;

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) {
        fetch('/cart.js').then(r => r.json()).then(c => {
          document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => el.textContent = c.item_count);
        });
        return;
      }

      // 1. Open drawer immediately so user sees it right away
      cartDrawer.classList.remove('is-empty');
      cartDrawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');

      // 2. Fetch the freshly-rendered cart-drawer section HTML
      fetch('/?section_id=cart-drawer')
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Replace the cart drawer inner contents
          const newCartDrawer = doc.querySelector('#CartDrawer');
          const currentCartDrawer = document.querySelector('#CartDrawer');
          if (newCartDrawer && currentCartDrawer) {
            currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
          }

          // Remove is-empty from drawer and footer
          const drawerInner = cartDrawer.querySelector('.drawer__inner');
          const drawerFooter = cartDrawer.querySelector('.drawer__footer');
          const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
          if (drawerInner)      drawerInner.classList.remove('is-empty');
          if (drawerFooter)     drawerFooter.classList.remove('is-empty');
          if (cartDrawerItems)  cartDrawerItems.classList.remove('is-empty');
          if (cartDrawer)       cartDrawer.classList.remove('is-empty');

          // Rebind overlay close
          const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => cartDrawer.close());

          // Update cart count bubble
          const newBubble = doc.querySelector('#cart-icon-bubble');
          const currentBubble = document.querySelector('#cart-icon-bubble');
          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
          giftCart();
        })
        .catch(() => { /* drawer already open */ });
    })
    .catch(error => {
      addToCartBtn.classList.remove('loading');
      addToCartBtn.disabled = false;
      if (errorMsg) {
        errorMsg.textContent = error.description || error.message || 'Error adding to cart.';
        errorMsg.style.display = 'block';
      }
      console.error('Cart API Error:', error);
    });
  }

  // ─── INIT ─────────────────────────────────────────────────────────────
  function init() {
    preloadImages();
    updateColorOptions(getModel(), true);
    updateImages();
    updateAddonImages();
    calculatePrice();

    modelInputs.forEach(r => r.addEventListener('change', () => { updateColorOptions(r.value); calculatePrice(); }));
    sizeInputs.forEach(r => r.addEventListener('change', () => {
      const container = document.querySelector('.fauji-bag-builder');
      if (container) {
        container.classList.add('size-changing');
        setTimeout(() => container.classList.remove('size-changing'), 400);
      }
      calculatePrice();
    }));
    interiorInputs.forEach(r => r.addEventListener('change', () => { updateImages(); calculatePrice(); }));
    
    // Strengthen mobile touch execution checks
    addonsCheckboxes.forEach(cb => {
      ['change', 'click'].forEach(evt => cb.addEventListener(evt, () => { 
        syncAddonExclusivity(cb);
        calculatePrice(); 
        updateAddonImages(); 
      }));
    });

    // Desktop Premium Magnifier Zoom (Isolated Component Zoom)
    const previewBox = document.querySelector('.preview-unified');
    if (previewBox && window.innerWidth >= 1024) {
      previewBox.addEventListener('mousemove', e => {
        const rect = previewBox.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        
        previewBox.style.transformOrigin = `${x}% ${y}%`;
        previewBox.style.transform = 'scale(2.2)';
      });
      
      previewBox.addEventListener('mouseleave', () => {
        previewBox.style.transformOrigin = 'center center';
        previewBox.style.transform = 'scale(1)';
      });
    }

    if (btnMinus) btnMinus.addEventListener('click', () => { if (qtyInput.value > 1) { qtyInput.value--; calculatePrice(); } });
    if (btnPlus) btnPlus.addEventListener('click', () => { qtyInput.value++; calculatePrice(); });
    
    if (addToCartBtn) addToCartBtn.addEventListener('click', () => handleCheckout(false));
    if (stickyAtcBtn) stickyAtcBtn.addEventListener('click', () => handleCheckout(false));
    if (buyNowBtn) buyNowBtn.addEventListener('click', () => handleCheckout(true));

    tabBtns.forEach(btn => btn.addEventListener('click', () => {
      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanes.forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(btn.dataset.tab).classList.add('active');
    }));
  }

  init();
});
